import { AdminReportConfiguration } from '@recruitee/http-types';
import { createSingleEntityStore } from '@recruitee/ngrx';

import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<AdminReportConfiguration | null>()(EntityStoreKey.reportConfiguration);

export {
  actions as ReportConfigurationActions,
  selectors as ReportConfigurationSelectors,
  reducer as ReportConfigurationReducer,
  namespace as ReportConfigurationNamespace,
};
